import {
  ChangeEventHandler,
  FocusEventHandler,
  KeyboardEventHandler,
  useState,
  useRef,
} from 'react';

export type UseSeparateInputProps = {
  onApply: (value: string) => void;
  onCancel?: () => void;
  onChange?: (value: string) => void;
  defaultValue?: string | undefined | null;
};
export const useSeparateInput = (props: UseSeparateInputProps) => {
  const { onCancel } = props;
  const defaultValue = props.defaultValue ?? '';

  const [value, setValue] = useState(defaultValue);

  const escaping = useRef(false);

  const onKeyDown: KeyboardEventHandler<HTMLInputElement> = (evt) => {
    switch (evt.key) {
      case 'Enter':
        evt.currentTarget.blur();
        return;
      case 'Escape':
        setValue(defaultValue);
        //after setValue, onBlur will not call props.onApply because values are equal
        if (onCancel) {
          onCancel();
        }
        escaping.current = true;
        evt.currentTarget.blur();
        return;
    }
  };

  const onChange: ChangeEventHandler<HTMLInputElement> = (evt) => {
    setValue(evt.target.value);
    if (props.onChange) {
      props.onChange(evt.target.value);
    }
  };

  const onBlur: FocusEventHandler<HTMLInputElement> = () => {
    if (escaping.current) {
      escaping.current = false;
      return;
    }

    const trimmed = value.trim();
    if (trimmed !== defaultValue.trim()) {
      props.onApply(trimmed);
    }
  };

  return {
    onKeyDown,
    onChange,
    onBlur,
    value,
  };
};
